import { useEffect } from "react";
import { getChangeOrderDocumentData } from "../ducks/actions";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";

export default function ChangeOrderDocument() {
  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const changeOrderId = pathSegments[pathSegments.length - 2];
  const documentData = useAppSelector((state) => state?.contract?.documentData);

  useEffect(() => {
    if (changeOrderId) {
      dispatch(getChangeOrderDocumentData(changeOrderId));
    }
  }, [dispatch, changeOrderId]);
  return (
    <div className="changeOrderDocument">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "57px",
        }}
      >
        <div className="document_logo">
          <img src="/images/document/company-logo.png" alt="" />
        </div>
        <div className="address_bar">
          <div className="address_card">
            <h2 className="normal_text"> Contractor </h2>
            <h2 className="bold_text"> {documentData?.data?.company_name} </h2>
            <h2 className="normal_text">
              {" "}
              {documentData?.data?.contractor_address}{" "}
            </h2>
          </div>
          <div className="address_card">
            <h2 className="normal_text"> Client </h2>
            <h2 className="bold_text"> {documentData?.data?.client_name} </h2>
            <h2 className="normal_text">
              {" "}
              {documentData?.data?.client_address}{" "}
            </h2>
          </div>
        </div>
      </div>

      <div className="document_content">
        <h2> Change order </h2>

        <h3 className="subject">
          To agreement:
          <span> {documentData?.data?.agreement_name} </span>
        </h3>
        <h3 className="subject" style={{ marginBottom: "24px" }}>
          Effective date:
          <span> {documentData?.data?.effective_date} </span>
        </h3>

        <p style={{ marginBottom: "4px" }}>
          This Change order is made and entered into as of Effective date, by
          and between Contractor and Customer.
        </p>
        <p style={{ marginBottom: "16px" }}>
          This Change order modifies the Agreement between Contractor and
          Customer (the “Agreement”). All terms and conditions of the Agreement
          remain in full force and effect except as expressly modified herein.
        </p>

        <h4 style={{ marginBottom: "6px" }}> Scope of change </h4>
        <p style={{ marginBottom: "10px" }}>
          The parties agree to the following modifications to the Agreement:
        </p>
        <ul>
          {documentData?.data?.scope_of_change?.map((item, index) => (
            <li key={index} style={{ marginBottom: "8px" }}>
              {item?.service_line_name} gross margin changes from $
              {item?.oldValue} to ${item?.newValue}{" "}
            </li>
          ))}
        </ul>

        <h4 style={{ marginBottom: "4px" }}>
          Adjustment to the Agreement price
        </h4>
        <p style={{ marginBottom: "10px" }}>
          Below is the original and new total agreement amount.
        </p>

        <h3 className="subject">
          Original price:
          <span style={{ fontWeight: "700" }}>
            {" "}
            $
            {Number(
              documentData?.data?.original_price?.toFixed(2)
            ).toLocaleString()}{" "}
          </span>
        </h3>
        <h3 className="subject" style={{ marginBottom: "24px" }}>
          New price:
          <span style={{ fontWeight: "700" }}>
            {" "}
            $
            {Number(
              documentData?.data?.new_price?.toFixed(2)
            ).toLocaleString()}{" "}
          </span>
        </h3>
      </div>

      <div className="signature_section">
        <div className="left">
          <div className="by_div">
            By <br />
            <span style={{ fontWeight: "700" }}>Evergreen Landscapes</span>
          </div>
          <div className="signatureBox"></div>
          <div className="signature_details">
            <h6 style={{ marginBottom: "16px" }}>
              Alex Morgan
              <br />
              Business Development Manager
            </h6>
            <h6>Date: Jun 20, 2025</h6>
          </div>
        </div>
        <div className="right">
          <div className="accepted_by">
            Accepted by <br />
            <span style={{ fontWeight: "700" }}>Office Park Holdings, LLC</span>
          </div>
          <div className="signature_details">
            <div className="signatureBox"></div>
            <h6 style={{ marginBottom: "16px" }}>
              Alex Morgan
              <br />
              Business Development Manager
            </h6>
            <h6>Date: Jun 20, 2025</h6>
          </div>
        </div>
      </div>
    </div>
  );
}
